import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CookiesLocalService } from "../service/cookies-local.service";
import { IGuardian } from "../model/IGuardian";
import { ApplicantService } from "../service/applicant.service";
import { BehaviorModelChangeService } from "../service/behavior-model-change.service.service";
import { ComponentBase } from "../base/component-base";
import { ToastrService } from "ngx-toastr";
import { DialogService } from "../service/dialog-service";
import { Configuration } from "../configuration";
import { UtilService } from "../service/util.service";

@Component({
  selector: "app-application-summary",
  templateUrl: "./application-summary.component.html",
  styleUrls: ["./application-summary.component.css"],
})
export class ApplicationSummaryComponent
  extends ComponentBase
  implements OnInit
{
  guardianData: IGuardian;
  applicantProgrammeOfChoices: any[];
  examinationData: any[];
  examinationItems: any[];
  examIds: any[];
  invalidPersonalInfo: boolean;
  invalidGuardianInfo: boolean;
  invalidContactInfo: boolean;

  constructor(
    private router: Router,
    applicantService: ApplicantService,
    cookieLocal: CookiesLocalService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    behaviorModelChangeService: BehaviorModelChangeService,
    private utilService: UtilService
  ) {
    super(applicantService, cookieLocal, behaviorModelChangeService);
  }

  ngOnInit() {
    this.guardianData = this.cookieLocal.getGuardianData();
    this.utilService.getRegions().subscribe((data) => {
      if (data.filter((d) => d.ValueId == this.guardianData.RegionId)[0]) {
        this.guardianData.RegionName = data.filter(
          (d) => d.ValueId == this.guardianData.RegionId
        )[0].DisplayValue;
      } else {
        this.guardianData.RegionName = "";
      }
    });
    this.applicantData = this.cookieLocal.getApplicantData();

    this.applicantService
      .geApplicantProgrammeOfChoice(this.applicantData.ApplicationId)
      .subscribe(
        (data) => {
          this.applicantProgrammeOfChoices = data.SelectedProgrammes;
        },
        (error) => {
          console.log(error);
        }
      );

    this.applicantService
      .getApplicantExaminationDetails(this.applicantData.ApplicationId)
      .subscribe((data) => {
        this.examinationData = this.getGroupBy(data, "ApplicantExaminationId");
      });

    this.invalidPersonalInfo = !this.applicantData.FirstName;
    this.invalidGuardianInfo = !this.guardianData.Name;
    this.invalidContactInfo = !this.applicantData.PrimaryNumber;
  }

  getExamItem(item) {
    return [item.Items[0]];
  }

  getGroupBy(collection: any[], property) {
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }

      return previous;
    }, {});

    return Object.keys(groupedCollection).map((key) => ({
      key,
      Items: groupedCollection[key],
    }));
  }

  save(form: any): boolean {
    if (!form.valid) {
      return false;
    }
    return true;
  }

  onSubmit() {}

  goToPrevious() {
    this.router.navigate(["/applicant/info/programme-selection"]);
  }

  getProgrammeChoiceName(id) {
    if (id == 1) {
      return "First (1st)";
    }
    if (id == 2) {
      return "Second (2nd)";
    }
    if (id == 3) {
      return "Third (3rd)";
    }
    if (id == 4) {
      return "Fourth (4th)";
    }
  }

  getExaminationItem(applicantExaminationId) {
    return [
      this.examinationItems.filter(
        (a) => a.ApplicantExaminationId == applicantExaminationId
      )[0],
    ];
  }

  getGrades(header) {
    let data = this.examinationItems.filter(
      (a) => a.ApplicantExaminationId == header.ApplicantExaminationId
    );
    return data;
  }

  getGradeValues(applicantExaminationItemId) {
    let data = this.examinationItems.filter(
      (a) => a.ApplicantExaminationItemId == applicantExaminationItemId
    );
    return "";
  }

  onPrint() {
    if (this.invalidPersonalInfo) {
      this.toastr.warning("Please complete your personal information");
      return;
    }

    if (this.invalidContactInfo) {
      this.toastr.warning("Please complete your contact information");
      return;
    }
    if (this.invalidGuardianInfo) {
      this.toastr.warning("Please complete your parent/guardian information");
      return;
    }

    if (!this.isPostgraduateStudent()) {
      if (
        this.applicantProgrammeOfChoices.length == 0 &&
        !this.isPostgraduateStudent()
      ) {
        this.toastr.warning(
          "Programme of choice is not selected. Fill before you can print"
        );
        return;
      }

      if (this.errorCount > 0) {
        this.toastr.warning(
          "Examination grades is filled with errors. Fill before you can print"
        );
        return;
      }
    }

    this.applicantService
      .getApplicantAdmissionReport(this.applicantData.ApplicationId)
      .subscribe(
        (data) => {
          localStorage.setItem(
            Configuration.localStorageData.pdfPath,
            data.UrlPath
          );

          this.router.navigate(["/applicant/info/download"]);
        },
        (error) => {
          this.showLoadingIndicator = false;
          this.errrorMessage = error;
          console.log(this.errrorMessage);
        },
        () => {
          this.showLoadingIndicator = false;
        }
      );
  }

  errorCount = 0;

  getValidExamItems(items: any[]) {
    let hasError = items.filter((a) => a.GradeValue).length == 0;

    if (hasError) this.errorCount += 1;

    return items.filter((a) => a.GradeValue);
  }
}
